module.exports = __webpack_public_path__ + "static/media/cwu.6fb17b31.svg";